import apiService from '../../../services/api-client';
import { PutBlockUserResponse } from '../interfaces/put-block-user';
import { GetUserParams, GetUserResponse } from '../interfaces/get-user';
import { GetUsersParams } from '../interfaces/get-users';
import { PutUserPayload, PutUserResponse } from '../interfaces/put-user';
import { PutUnblockUserResponse } from '../interfaces/put-unblock-user';
import { PostUserPayloadRequest, PostUserResponse } from '../interfaces/post-user';
import { GetCompaniesResponse } from '../interfaces/get-companies';
import { User } from '../../../interfaces/user.interface';

export interface GetUsersOptions {
  text?: string | null;
  active?: boolean | null;
  role?: string | null;
}

export const usersApiService = {
  async getUsers(options?: GetUsersOptions) {
    const params = new URLSearchParams();
    if (options?.text) {
      params.append('text', options.text);
    }
    if (options?.active !== null && options?.active !== undefined) {
      params.append('is_active', String(options.active));
    }
    if (options?.role) {
      params.append('role', options.role);
    }

    const queryString = params.toString();
    const endpoint = `/users${queryString ? `?${queryString}` : ''}`;

    const { data } = await apiService().get<User[]>(endpoint);
    return data;
  },
  async getCompanyUsers(companyId: string): Promise<User[]> {
    const { data } = await apiService().get<User[]>(`/companies/${companyId}/users`);
    return data;
  },
  async deleteUser(userId: string): Promise<void> {
    await apiService().delete(`/users/${userId}`);
  },

  async getUser(id: string) {
    const { data } = await apiService().get<User>(
      `users/${id}`
    );
    return data;
  },
  async getUserByEmail(params: GetUserParams) {
    const { data } = await apiService().get<User>(
      `users/email/${params.email}`
    );
    return data;
  },
  async postUser(body: PostUserPayloadRequest) {
    const payloadForApi = {
      email: body.email,
      full_name: body.name,
      phone_number: body.phone_number,
      country: body.country,
      city: body.city,
      password: body.password,
      company_ids: [parseInt(body.companyId)],
      role: body.role,
    };
    const { data } = await apiService().post<PostUserResponse>(
      `/users`,
      payloadForApi
    );
    return data;
  },
  async putUser(id: string, body: PutUserPayload) {
    console.log(body)
    const { data } = await apiService().put<PutUserResponse>(`/users/${id}`, {
      email: body.email,
      full_name: body.fullName,
      phone_number: body.phone_number,
      role: body.role
    });
    return data;
  },
  async putBlockUser(id: string) {
    const { data } = await apiService().put<PutBlockUserResponse>(
      `users/block/${id}`
    );
    return data;
  },
  async putUnblockUser(id: string) {
    const { data } = await apiService().put<PutUnblockUserResponse>(
      `users/unblock/${id}`
    );
    return data;
  },
  async getCompanies(id: string) {
    const { data } = await apiService().get<GetCompaniesResponse>(
      `users/${id}/companies`,
    );
    return data;
  },
};
